import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { style } from '../../utils/style.js';
import { Img } from '../Img/Img.js';
const getButtonClassNames = (isActive) => ({
    btn: `w-96 ${isActive ? 'p-m border-none bg-primary-main text-white' : 'p-s ease-in duration-300 bg-white'}`,
    text: isActive ? 'mb-xs text-xl' : 'mb-2xs text-l text-primary-text',
    desc: `font-light ${isActive ? 'text-l text-white' : 'text-m text-secondary-text'}`,
    icon: isActive ? '' : 'text-primary-main',
    iconVersion: (isActive ? 'white' : 'normal'),
    oldText: 'text-m text-center',
    oldDesc: 'text-m-light',
});
export const renderTabItemInner = ({ text, description, icon, isActive, type, }) => {
    const buttonClassNames = getButtonClassNames(isActive);
    return (_jsxs("div", { className: style('cursor-pointer text-left border-b-0 flex gap-2xs'), "aria-label": text, "aria-labelledby": `${text}-label`, children: [icon ? (_jsx(Img, { className: style('h-6 w-6 min-w-6 min-h-6', buttonClassNames.icon), image: {
                    ...icon,
                    iconVersion: icon?.iconVersion ?? buttonClassNames.iconVersion,
                }, width: "24", height: "24", alt: text })) : null, _jsxs("div", { className: "border-0", children: [_jsx("div", { className: type === 'animated' ? buttonClassNames.text : buttonClassNames.oldText, children: text }), _jsx("div", { className: type === 'animated' ? buttonClassNames.desc : buttonClassNames.oldDesc, children: description })] })] }));
};
//# sourceMappingURL=renderTabItemInner.js.map